export const REPORTING_DOCUMENTS_SET = 'REPORTING_DOCUMENTS_SET';
export const REPORTING_SET_LOADING = 'REPORTING_SET_LOADING';
export const REPORTING_RUN_QUERY = 'REPORTING_RUN_QUERY';
export const REPORTING_EXPORT_TO_XLS = 'REPORTING_EXPORT_TO_XLS';
